import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Tracks active HTTP request count for a global loader overlay.
 *
 * This remains framework-agnostic and is controlled by LoaderInterceptor.
 */
@Injectable({
  providedIn: 'root'
})
export class HttpLoaderService {
  private activeRequestCount = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

  start(): void {
    this.activeRequestCount += 1;
    if (this.activeRequestCount === 1) {
      queueMicrotask(() => {
        if (this.activeRequestCount > 0) {
          this.loadingSubject.next(true);
        }
      });
    }
  }

  stop(): void {
    if (this.activeRequestCount > 0) {
      this.activeRequestCount -= 1;
    }

    if (this.activeRequestCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  reset(): void {
    this.activeRequestCount = 0;
    this.loadingSubject.next(false);
  }
}
